import { Box, Typography, Container } from "@mui/material";

const Footer = () => (
  <Box
    component="footer"
    sx={{
      py: 3,
      mt: "auto",
      bgcolor: "background.paper",
      textAlign: "center",
    }}
  >
    <Container>
      <Typography variant="body2" color="text.secondary">
        © {new Date().getFullYear()} Craig Lawlor. All Rights Reserved.
      </Typography>
    </Container>
  </Box>
);

export default Footer;